<template>
  <div class="sn-toggle" :class="{ 'sn-toggle--active': !!value }">
    <label v-if="label" :for="id" class="sn-toggle__label" :data-text="label">{{ label }}</label>
    <label class="switch">
      <input v-model="model"
             :id="id"
             type="checkbox">
      <span class="slider round"/>
      <span class="value-in-words checked"/>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'SnToggle',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: null
      },
      id: {
        type: String,
        default: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables.scss';

  .sn-toggle {
    font-family: 'MotivaSans Light';
    font-size: 1.5rem;
    display: flex;
    column-gap: 6px;
    align-items: center;
    color: $gunmetal;

    &__label {
      display: inline-block;
      text-align: center;
      cursor: pointer;

      &:after {
        display: block;
        content: attr(data-text);
        font-family: 'MotivaSans SemiBold';
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }
    }

    &--active {
      color: $dark-chestnut-brown;
      font-family: 'MotivaSans SemiBold';
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 23px !important;
    height: 15px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: .4s;
    transition: .4s;
    border: 2.5px solid $quick-silver;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 7.5px;
    width: 7.5px;
    left: 1.5px;
    bottom: 1.5px;
    background-color: $quick-silver;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: $dark-chestnut-brown;
    border-color: $dark-chestnut-brown;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px $dark-chestnut-brown;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(7.5px);
    -ms-transform: translateX(7.5px);
    transform: translateX(7.5px);
    background-color: $color-white;
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
